import { useNavigate } from "react-router-dom"
import { LINKS } from "../constants/links"
import { useCallback } from "react"

export default function useSupplyPointNavigation() {
  const navigate = useNavigate()

  return useCallback((id: number) => navigate(LINKS.pdt(id)), [navigate])
}
